"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterNulls = void 0;
var isNotNull_1 = require("../isNotNull");
function filterNulls(arr) {
    return arr.filter(isNotNull_1.isNotNull);
}
exports.filterNulls = filterNulls;
